import $ from "jquery";

const divElement = $("#deliverables-sequence");
let isImageLoading = false;
let imageCache = [];

if (divElement.length) {
  const locationIS = "/wp-content/themes/createit20/assets/img/deliverables_img_seq_compressed";
  let canvasFrameCount = 0;
  const windowWidth = $(window).width();
  let imgSeqPack = '';
  const canvasImgHeight = $("#deliverables-sequence").height();
  let orientation = 'desktop';
  let jsCanvasAdjustment = 0;
  
  if (windowWidth >= 1024) {
    imgSeqPack = '_2560/';
    canvasFrameCount = 225;
    jsCanvasAdjustment = 70;
  } else if (windowWidth >= 751) {
    imgSeqPack = '_768/';
    canvasFrameCount = 222;
    jsCanvasAdjustment = - canvasImgHeight * 0.05;
  } else {
    imgSeqPack = '_mobile/';
    canvasFrameCount = 180;
    orientation = 'mobile';
    jsCanvasAdjustment = canvasImgHeight * 0.6;
  }

  const canvasCurrentFrame = (index) =>
    `${ajax_urls["home"]}${locationIS}${imgSeqPack}${index
      .toString()
      .padStart(5, "0")}.webp`;

  // Function to load an image and return a promise
  const loadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.onload = () => resolve(img);
      img.onerror = reject;
    });
  };

  // Function to preload all images
  const preloadCanvasImages = () => {
    const imagePromises = [];
    for (let i = 1; i <= canvasFrameCount; i++) {
      const imageSrc = canvasCurrentFrame(i);
      const imagePromise = loadImage(imageSrc);

      imagePromises.push(imagePromise);
      imageCache.push({ index: i, src: imageSrc, promise: imagePromise });
    }
    return Promise.all(imagePromises);
  };

  function initCanvas() {
    // Set the initial background image of the div
    divElement.css("background-image", `url(${canvasCurrentFrame(1)})`);
  }

  const updateImage = (index) => {
    if (!isImageLoading) {
      isImageLoading = true;
      const imageInfo = imageCache.find((item) => item.index === index);

      if (imageInfo) {
        imageInfo.promise
          .then((img) => {
            // Image loaded, set it as the background image
            divElement.css("background-image", `url(${img.src})`);
            isImageLoading = false; // Set the flag to false
          })
          .catch((error) => {
            console.error("Error loading image: ", error);
            isImageLoading = false; // Make sure to set the flag to false on error
          });
      }
    }
  }

  $(window).on("load", function () {
    initCanvas();

    // Preload images and then start updating the background
    preloadCanvasImages().then(() => {
      // Start updating the background with images as the user scrolls
      $(window).on("scroll", function () {
        const jsCanvasSection = $(".section--deliverables .inner-section");
        const jsCanvasSectionOffset = jsCanvasSection.offset().top;
        const jsCanvasSectionBefore = $(".section--uncertainty").height();
        const jsCanvasStart =
          $(this).scrollTop() +
          $(this).height() -
          jsCanvasSectionBefore +
          jsCanvasAdjustment;
        const jsCanvasMaximum = jsCanvasStart - jsCanvasSectionOffset;
        const jsCanvasProgress =
          jsCanvasMaximum / (jsCanvasSection.height() * 2);
        if (jsCanvasStart >= jsCanvasSectionOffset) {
          const frameIndex = Math.min(
            canvasFrameCount - 1,
            Math.ceil(jsCanvasProgress * canvasFrameCount)
          );

          requestAnimationFrame(() => updateImage(frameIndex + 1));
          divElement.css("position", "fixed");
        } else {
          divElement.css("position", "absolute");
        }
      });
    });
  });
}
